export const COMMENTS_PAGE_SIZE = 4;
export const COMMENTS_CAROUSEL_PHOTOS_PAGE_SIZE = 8;
export const COMMENTS_GALLARY_MODAL_PHOTOS_PAGE_SIZE = 15;